import React from "react";
import {Link} from "react-router-dom";

function ForgotPasswordPage() {
    return (
        <section className="contact section-padding">
            <div className="w-layout-blockcontainer container w-container">
                <div data-w-id="44130a78-0466-a8d4-6bde-6b77b0115ef6"
                     className="content-wrapper contact">
                    <div className="section-title center">
                        <p className="label">Forgot Password</p>
                        <div className="title center">
                            <h2 className="heading-2 text-align-center">Let's Get Started</h2>
                        </div>
                    </div>
                    <div className="single-contact-address stoke">
                        <div className="contact-form-wrapper">
                            <div className="form-wrapper w-form">
                                <form id="wf-form-Contact-Form" name="wf-form-Contact-Form" data-name="Contact Form"
                                      method="get" className="contact-form space-y-8"
                                      data-wf-page-id="66e658e34f137113ddc5e097"
                                      data-wf-element-id="e56cb1d5-1c62-eb4c-1ffc-e6a97a04db2e">
                                    <div className="form-item-wrapper">
                                        <label htmlFor="Email" className="body-text-16 text-neutral-01">Email
                                            *</label>
                                        <input className="input-item body-text-16 w-input" maxLength="256"
                                               name="Email" data-name="Email" placeholder="youremail@gmail.com"
                                               type="email" id="Email" required=""/>
                                    </div>
                                    <input type="submit" data-wait="Please wait..."
                                           className="submit-button bg-theme-color-01 button-text w-button"
                                           value="Submit"/>
                                    <div className="flex justify-between">
                                        <Link to="/login">
                                            <p className="label">Go To Login page</p>
                                        </Link>
                                        <Link to="/">
                                            <p className="label">Go To Homepage</p>
                                        </Link>
                                    </div>
                                </form>
                                <div className="w-form-done">
                                    <div>Thank you! Your submission has been received!</div>
                                </div>
                                <div className="w-form-fail">
                                    <div>Oops! Something went wrong while submitting the form.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ForgotPasswordPage;